import { Button, Tooltip } from "antd";
import { GetAntIcon } from "../../utils/ant_icons";

interface ReportItemEditButtonProps {
	// The item's number, such as "#Findings 3", for screen readers.
	itemNumber?: string;
	onClick: () => void;
}

// The edit icon on a finding or follow-up action card of a report page.
function ReportItemEditButton(props: Readonly<ReportItemEditButtonProps>) {
	const { itemNumber, onClick } = props;

	return (
		<Tooltip title="Edit">
			<Button
				type="text"
				size="small"
				icon={GetAntIcon("edit")}
				aria-label={itemNumber ? `Edit ${itemNumber}` : "Edit"}
				onClick={onClick}
			/>
		</Tooltip>
	);
}

export default ReportItemEditButton;
